import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-6xl mx-auto p-8 bg-white shadow-lg rounded-lg text-gray-800 mt-8">
      <h1 className="text-4xl font-bold mb-6 text-center text-green-600">Privacy Policy</h1>
      <p className="mb-6 text-lg text-gray-600 text-center">Your privacy is important to us at <strong>Investycoons</strong>. This Privacy Policy outlines how we collect, use, and protect your personal information.</p>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">1. Information We Collect</h2>
        <p>We may collect personal information such as your name, email address, phone number, and property preferences when you interact with our platform.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">2. How We Use Your Information</h2>
        <p>We use your data to provide, improve, and personalize our services, including property recommendations, customer support, and marketing communications.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">3. Data Sharing and Protection</h2>
        <p>We do not sell your personal data to third parties. However, we may share information with trusted partners for service-related purposes under strict confidentiality agreements.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">4. Cookies and Tracking</h2>
        <p>We use cookies to enhance your experience and analyze website traffic. You can control cookie settings through your browser preferences.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">5. Your Rights</h2>
        <p>You have the right to access, update, or delete your personal information. Contact us if you wish to exercise these rights.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">6. Changes to This Policy</h2>
        <p>We may update this Privacy Policy periodically. Continued use of our services signifies acceptance of any modifications.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">7. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at <strong>connect@investycoons.com</strong></p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;